import facebookLogo from "@assets/social_media/Facebook.svg";
import tiktokLogo from "@assets/social_media/tiktok.svg";
import { TABLA_SECTIONS } from "@config/SectionRoutesConstants";
import { HeaderMenuDetails } from "@typings/constants";

export const HEADER_SOCIAL_MENU: HeaderMenuDetails[] = [
  {
    alt: "facebook",
    url: "https://www.facebook.com/tablasph/",
    images: facebookLogo,
    newTab: true,
    height: 20,
    width: 20,
  },
  {
    alt: "tiktok",
    url: "https://www.tiktok.com/@tablatoks",
    images: tiktokLogo,
    newTab: true,
    height: 20,
    width: 20,
  },
];

const SECTION_MAIN_MENU_ITEMS: HeaderMenuDetails[] = TABLA_SECTIONS.map(
  ({ title, slug }) => ({
    title,
    url: `/${slug}`,
  }),
);

export const HEADER_MAIN_MENU: HeaderMenuDetails[] = SECTION_MAIN_MENU_ITEMS;

export const HEADER_HAMBURGER_MENU: HeaderMenuDetails[] = [
  ...SECTION_MAIN_MENU_ITEMS,
  // {
  //   title: "Picture Gallery",
  //   url: "/picture-gallery",
  // },
  // {
  //   title: "Quick News",
  //   url: "/quick-news",
  // },
  {
    title: "ePaper",
    url: "https://e-paper.sph.com.sg/tabla",
    newTab: true,
  },
];
